import Immutable from 'immutable';

import {
	webapi,
	createModuleState,
	REPORTED_EXCEPTION,
	showMessageBox
} from 'ps-gui';
import { getPhrase } from '../../data/phrases';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_LIST = Immutable.List([]);
const EMPTY_STATE = createModuleState('UserProfile');

export default class UserProfileModel {
	#data;

	constructor(data) {
		this.#data = data || EMPTY_MAP;
	}

	#setProperty(name, value) {
		if (Array.isArray(name)) {
			return new UserProfileModel(this.#data.setIn(name, value));
		} else {
			return new UserProfileModel(this.#data.set(name, value));
		}
	}

	async initialize() {
		let res = await this.load();
		return res.#setProperty('initialized', true);
	}

	setSelectedTabId(value) {
		return this.#setProperty('selectedTabId', value);
	}

	setPasswordChangeProperty(name, value) {
		return this.#setProperty(['passwordChange', name], value);
	}

	getPasswordChangeData() {
		return this.#data.get('passwordChange') || EMPTY_MAP;
	}

	async setPassword() {
		const pwdChange = this.getPasswordChangeData();
		try {
			await webapi.execute('/api/user/setPassword', {
				oldPassword: pwdChange.get('oldPwd'),
				newPassword: pwdChange.get('pwd1')
			});
		} catch (ex) {
			if (ex === 'userInvalidPassword') {
				return this.setPasswordChangeProperty('oldPasswordError', getPhrase('invalidPassword'));
			} else {
				return this.setPasswordChangeProperty('oldPasswordError', getPhrase(ex));
			}
		}
		showMessageBox(getPhrase('passwordHasBeenChanged'));
		return this.#setProperty('passwordChange', EMPTY_MAP);
	}

	toggleAltNamesExpanded(index) {
		let data = this.#data;
		const path = [
			'profile',
			'parties',
			index,
			'altNamesExpanded'
		];
		data = data.setIn(path, !data.getIn(path));
		return new UserProfileModel(data);
	}

	async load() {
		const profile = await webapi.execute('/api/proc/api_user/getuserprofile');
		if (profile === REPORTED_EXCEPTION) {
			return this;
		}
		const bankIds = await webapi.execute('/api/proc/api_bankidentity/getMyBankIdentities');
		if (bankIds === REPORTED_EXCEPTION) {
			return this;
		}
		return this.#setProperty('profile', Immutable.fromJS(profile)).#setProperty('bankIds', Immutable.fromJS(bankIds));
	}

	async deleteBankIdentity(id) {
		const res = await webapi.execute('/api/proc/api_bankidentity/deleteBankIdentity', { id });
		return this.load();
	}

	getData() {
		return this.#data;
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}

	getSelectedTabId() {
		return this.#data.get('selectedTabId') || 'profile';
	}

	// These getters return values for menu tabs

	getProfile() {
		return this.#data.get('profile') || EMPTY_MAP;
	}

	getBankIdentities() {
		return this.#data.get('bankIds');
	}

	getParties() {
		return this.#data.getIn(['profile', 'parties']) || EMPTY_LIST;
	}
}

